import { Box, Table, Text } from "@mantine/core";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelectFlagData } from "../../../../redux/features/flagDetails/flagDetailsSlice";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import { dateFormat, dateWithHourFormat } from "../../../../utils/dateFormat";
import { resolutionStatuses } from "../../../../utils/vars";
import EditDescriptionModal from "./EditDescriptionModal";
import { useCheckPermission } from "../../../../hooks/useCheckPermission";
import { TableNoResults } from "../../../../components/TableNoResults/TableNoResults";
import ResolutionHistorySkeleton from "../../../../components/Skeletons/FlagDetailsSkeletons/ResolutionHistorySkeleton";

const ResolutionHistoryTable = () => {
  const resolutionTextPermission = useCheckPermission("RESOLUTION_TEXT");
  const { id } = useParams();
  const { t } = useTranslation();
  const flagData = useSelectFlagData();

  const { isLoading: isLoadingData } = useQuery({
    queryKey: ["flag-details", id],
    enabled: false, // only reads from store
  });

  const rows = flagData?.resolutionStatusHistory?.slice(0, 3)?.map((stat) => (
    <Table.Tr key={stat.name}>
      <Table.Td>{dayjs(stat.date).format(dateWithHourFormat)}</Table.Td>
      <Table.Td>{resolutionStatuses[stat.status]}</Table.Td>
      <Table.Td>{stat?.user?.name}</Table.Td>
      <Table.Td>
        <EditDescriptionModal id={stat.id} rowText={stat.description} />
      </Table.Td>
      <Table.Td>
        {dayjs(stat.dueDate).isValid()
          ? dayjs(stat.dueDate).format(dateFormat)
          : null}
      </Table.Td>
      <Table.Td>
        {dayjs(stat.dueDateCheck).isValid()
          ? dayjs(stat.dueDateCheck).format(dateFormat)
          : null}
      </Table.Td>
    </Table.Tr>
  ));

  if (!resolutionTextPermission) return null;

  if (isLoadingData) {
    return <ResolutionHistorySkeleton />;
  }

  return (
    <Box>
      <Text fw={700} p="md">
        {t("flagDetails.resolutionStatusHistory.resolutionHistory")}
      </Text>
      <Table withTableBorder withColumnBorders>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>{t("flagDetails.date")}</Table.Th>
            <Table.Th>
              {t("flagDetails.resolutionStatusHistory.resolutionStatus")}
            </Table.Th>
            <Table.Th>
              {t("flagDetails.resolutionStatusHistory.employee")}
            </Table.Th>
            <Table.Th>
              {t("flagDetails.resolutionStatusHistory.description")}
            </Table.Th>
            <Table.Th>
              {t("flagDetails.resolutionStatusHistory.dueDate")}
            </Table.Th>
            <Table.Th>
              {t("flagDetails.resolutionStatusHistory.dueDateCheck")}
            </Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {rows.length > 0 ? rows : <TableNoResults colSpan={6} />}
        </Table.Tbody>
      </Table>
    </Box>
  );
};

export default ResolutionHistoryTable;
